import consumers from './consumers'

const setUserId = (userId) => {
  consumers.forEach((consumer) => consumer.setUserId(userId))
}

export default setUserId
